import {
  SIGNATURE_COMPLETED,
  ROLE_SELECTED,
  MARKETING_INFORMATION_COLLECTED,
  PARTICIPANT_DATA_COLLECTED,
  SIGNER_NAME_COLLECTED,
  PARTICIPANTS_COLLECTED,
  LINKED_PARTICIPANT,
  LINKED_PARTICIPANT_SELECTED,
  LINKED_PARTICIPANTS_SELECTED,
  LINKED_PARTICIPANTS_SIGNEDBY,
  LINKED_PARTICIPANTS_COLLECTED,
  PARTICIPANTS_AND_SIGNER_COLLECTED,
  NONE_SELECTED,
  NEXT_SELECTED,
  NEXT_CONFUSED,
  PARTICIPANTS_RESET
} from "../constants";
import { concat, isEmpty, merge, mergeAll, mergeDeepRight } from "ramda";

const initialSigningInfoState = {
  name: "", //validate: <50char, needs a space b/c its first and last name
  referenceKey: "",
  // isGuardian: false, //1
  // // isParticipant: false, //bool
  // // isBoth: false, //bool
  role: 0, //isGuardian || isParticipant || isBoth {1: isParticipant, 2: isGuardian, 3: isBoth}
  birthday: "",
  optIn: true, //bool
  phoneNumber: "", //must be # -> use react-intl-tel-input dependency
  email: "", //regEx validation
  icePhoneNumber: "", //must be # -> use react-intl-tel-input dependency
  signature: "", //image
  dateCreated: "", //date ISO format
  video: "", //video while reading signingStatement,
  participants: [
    // if isGuardian, then these will be their participants
    {
      participantName: "", //sameValidation for name above
      participantBirthday: "", //ISO format, **need format for input**
      referenceKey: ""
    }
  ],
  linkedParticipant: [
    {
      participantName: "", //sameValidation for name above
      participantBirthday: "", //ISO format, **need format for input**
      referenceKey: ""
    }
  ],
  errors: { email: "", phoneNumber: "", icePhoneNumber: "" }
  // selected: true
  //isValid: false
};

export const signingInfo = (state = initialSigningInfoState, action) => {
  switch (action.type) {
    //AboutSignerPage
    case ROLE_SELECTED:
      return merge(state, { role: Number(action.payload), selected: true });

    case NONE_SELECTED:
      return merge(state, { selected: false });

    case NEXT_SELECTED:
      return merge(state, { selected: true });

    case NEXT_CONFUSED:
      return merge(state, { selected: undefined });

    //BothDrop\\
    case PARTICIPANTS_RESET:
      return merge(state, {
        participants: initialSigningInfoState.participants,
        linkedParticipant: initialSigningInfoState.linkedParticipant
      });

    //MarketingInformation
    case MARKETING_INFORMATION_COLLECTED:
      return {
        ...state,
        phoneNumber: action.payload.phoneNumber,
        optIn: action.payload.optIn,
        email: action.payload.email,
        icePhoneNumber: action.payload.icePhoneNumber
      };
    case SIGNER_NAME_COLLECTED:
      return {
        ...state,
        name: action.payload.name,
        participants: concat(action.payload.participants, state.participants)
      };

    case PARTICIPANTS_COLLECTED:
      // console.log("PART_COLLECTEDAC", action.payload);
      //followupTest
      return {
        ...state,
        participants: action.payload.participants
      };

    case PARTICIPANTS_AND_SIGNER_COLLECTED:
      // console.log("PART_COLLECTEDAC", action.payload);
      return {
        ...state,
        participants: action.payload.participants,
        name: action.payload.name
      };

    case LINKED_PARTICIPANTS_COLLECTED:
      return {
        ...state,
        participants: action.payload.participants,
        name: action.payload.name
      };

    /////linkedParticipant\\\\
    case LINKED_PARTICIPANT:
      return merge(state, { id: action.payload });

    case LINKED_PARTICIPANT_SELECTED:
      return merge(state, action.payload);

    case LINKED_PARTICIPANTS_SELECTED:
      if (isEmpty(state.linkedParticipants)) {
        return mergeDeepRight(state, { participants: action.payload });
      } else {
        return mergeAll(state, { participants: action.payload });
      }

    case LINKED_PARTICIPANTS_SIGNEDBY:
      return merge(state, { name: action.payload });

    //ParticipantForm
    case PARTICIPANT_DATA_COLLECTED:
      return merge(state, action.payload);

    case SIGNATURE_COMPLETED:
      return merge(state, { signature: action.payload });

    default:
      return state;
  }
};
